<script>
import axios from 'axios'
import { createAdminUser } from '@/api/data'
import { getI18nLanguage } from '@/locales'
import md5 from 'md5'

export default {
  name: 'CreateAccount',
  props: ['layerid'],
  data () {
    return {
      form: this.$form.createForm(this),
      loading: false
    }
  },
  methods: {
    getErrorMessage (msg) {
      if (typeof msg === 'string') {
        return msg
      }
      const lang = getI18nLanguage()
      const langKey = lang.replace('-', '').toLowerCase()
      const enKey = 'en'
      const zhKey = 'zh'
      const jaKey = 'ja'
      if (langKey.includes('zh')) {
        return msg[zhKey] || msg['zh-CN'] || msg['en'] || msg['en-US'] || ''
      } else if (langKey.includes('ja')) {
        return msg[jaKey] || msg['ja-JP'] || msg['en'] || msg['en-US'] || ''
      } else {
        return msg[enKey] || msg['en-US'] || msg['en'] || ''
      }
    },
    handleSubmit () {
      const { form: { validateFields } } = this

      validateFields((err, values) => {
        if (!err) {
          this.loading = true

          const params = {
            name: values.name,
            account: values.account,
            passwd: md5(values.password)
          }

          createAdminUser(params)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('user.action.driverCreate.success'))
                this.form.resetFields()
                this.$layer.close(this.layerid)
                this.$parent.reloadTable()
              } else {
                this.$message.error(this.getErrorMessage(res.msg) || this.$t('user.action.driverCreate.fail'))
              }
            })
            .catch(() => {
              this.$message.error(this.$t('user.action.driverCreate.fail'))
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<template>
  <div style="width: 100%;padding: 8px;">
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-form-item :label="$t('user.name')">
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: $t('user.name.tip') }] }
          ]"
          :placeholder="$t('user.name.tip')"
        />
      </a-form-item>

      <a-form-item :label="$t('user.account')">
        <a-input
          autocomplete="off"
          v-decorator="[
            'account',
            { rules: [{ required: true, min: 5, pattern: /^[a-zA-Z0-9]+$/, message: $t('user.account.format') }] }
          ]"
          :placeholder="$t('user.account.format')"
        />
      </a-form-item>

      <a-form-item :label="$t('user.password')">
        <a-input
          type="password"
          autocomplete="new-password"
          v-decorator="[
            'password',
            { rules: [{ required: true, min: 6, message: $t('user.password.min.length') }] }
          ]"
          :placeholder="$t('user.password.min.length')"
        />
      </a-form-item>

      <a-form-item :wrapper-col="{ span: 15, offset: 5 }">
        <a-button
          type="primary"
          html-type="submit"
          :loading="loading"
          @click="handleSubmit"
        >
          {{ $t('user.action.driverCreate') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<style scoped lang='less'>
</style>
